import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Overlay, Label } from 'react-bootstrap';
import ScrollArea from 'react-scrollbar';
import { compact as _compact, split as _split, escapeRegExp as _escapeRegExp, isString as _isString } from 'lodash';

import { changeActivePage } from 'actions/ListActions';
import { parseQs, stringifyQs } from 'helpers/http';

import SidebarAwarePopover from 'components/SidebarAwarePopover';
import Loader from 'components/layout/Loader';
import ListFilterListEntry from 'components/layout/list/ListFilterListEntry';

import List from 'components/List';

class ListFilterAsyncSingle extends React.Component {
  constructor(props) {
    super(props);

    const { location, paramName } = props;

    const query = parseQs(location.search);
    const filterValue = query[paramName];

    let selectedValue = {};
    if (_isString(filterValue)) {
      selectedValue = {
        value: filterValue,
        label: localStorage.getItem(`filterLabel-${paramName}${filterValue}`) || filterValue,
      };
    }

    this.state = {
      show: false,
      page: 1,
      stateList: [],
      selectedValue,
      searchTextFocused: false,
      listSearchText: '',
    };

    this.headerRef = React.createRef();
    this.inputRef = React.createRef();
  }

  componentDidUpdate = prevProps => {
    const { list, location, paramName } = this.props;
    const { selectedValue: oldValue } = this.state;

    if (!list.pending && prevProps.list.pending) {
      this.setState(prevState => ({
        stateList: prevState.stateList.slice().concat(list.data.list),
      }));
    }

    if (location.search !== prevProps.location.search) {
      const query = parseQs(location.search);
      const filterValue = query[paramName];

      if (oldValue.value !== filterValue) {
        let selectedValue = {};
        if (filterValue) {
          selectedValue = {
            value: filterValue,
            label: localStorage.getItem(`filterLabel-${paramName}${filterValue}`) || filterValue,
          };
        }

        this.setState({ selectedValue });
      }
    }
  };

  componentWillUnmount = () => {
    clearTimeout(this.timeout);
  };

  show = e => {
    e.preventDefault();
    this.setState({ show: true });
  };

  close = () => {
    this.setState({ show: false });
  };

  onScroll = e => {
    const { list, listName, changeActivePage } = this.props;
    const { page } = this.state;

    const maxScoll = e.realHeight - e.containerHeight;

    if (maxScoll === e.topPosition && !list.pending && page * list.resPerPage < list.data.count) {
      this.setState(
        prevProps => ({ page: prevProps.page + 1 }),
        () => {
          changeActivePage(listName, page + 1, list.resPerPage);
        }
      );
    }
  };

  reset = e => {
    e.preventDefault();

    const { history, location, paramName } = this.props;
    const selectedValue = {};

    this.setState({ selectedValue }, () => {
      history.push({
        pathname: location.pathname,
        search: stringifyQs({ ...parseQs(location.search), [paramName]: undefined }),
      });
    });
  };

  updateFilter = (e, listItem) => {
    e.preventDefault();

    const { history, location, paramName, listItemId, listItemStringFormatter, listItemFormatter } = this.props;

    const value = listItemId(listItem);
    const label = listItemStringFormatter(listItem) || listItemFormatter(listItem);

    const selectedValue = {
      value,
      label,
    };

    this.setState({ selectedValue }, () => {
      history.push({
        pathname: location.pathname,
        search: stringifyQs({ ...parseQs(location.search), [paramName]: value }),
      });

      localStorage.setItem(`filterLabel-${paramName}${value}`, label);
    });
  };

  onSearchTextSubmit = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  onSearchTextFocus = () => {
    this.setState({ searchTextFocused: true });
  };

  onSearchTextBlur = () => {
    this.setState({ searchTextFocused: false });
  };

  onSearchTextChange = e => {
    const { complete } = this.props;

    clearTimeout(this.timeout);
    const listSearchText = e.target.value;
    this.timeout = setTimeout(
      () => this.setState(prevState => ({ listSearchText, page: 1, stateList: complete ? prevState.stateList : [] })),
      300
    );
  };

  resetSearchText = e => {
    const { complete } = this.props;

    e.preventDefault();
    this.setState(prevState => ({ listSearchText: '', page: 1, stateList: complete ? prevState.stateList : [] }));
    this.inputRef.current.value = '';
  };

  render() {
    const {
      title,
      listName,
      listUrl,
      listUrlData,
      list,
      listItemId,
      listItemStringFormatter,
      listItemFormatter,
      complete,
    } = this.props;
    const { show, listSearchText, searchTextFocused, selectedValue, stateList } = this.state;

    const listSearchTextParts = _compact(_split(listSearchText, ' '));

    return (
      <>
        <a
          href="#showFilterOptions"
          className={`list-filter ${show ? 'active' : ''}`}
          onClick={this.show}
          ref={this.headerRef}
        >
          {title}
          {!!selectedValue.value && (
            <Label className="m-l-5 label-primary-bg">
              <i className="fal fa-check" />
            </Label>
          )}
          <i className="fal fa-chevron-down m-l-10" />
        </a>

        <List
          noRender
          listName={listName}
          url={listUrl}
          urlData={{
            ...listUrlData,
            autocomplete: (!complete && listSearchText) || '',
          }}
        />

        <Overlay show={show} target={this.headerRef.current} placement="bottom" rootClose onHide={this.close}>
          <SidebarAwarePopover className="filter-popover">
            <ScrollArea
              speed={0.8}
              className=""
              contentClassName=""
              horizontal={false}
              style={{ overflow: 'hidden', height: '300px' }}
              onScroll={this.onScroll}
            >
              <div className="list-view clearfix">
                <div className="padding-10 m-b-5 b-b b-grey">
                  {!!selectedValue.value && (
                    <span className="filter-value">
                      <span>{selectedValue.label}</span>
                      <a href="#remove" onClick={this.reset}>
                        <i className="fal fa-times" />
                      </a>
                    </span>
                  )}

                  <div className={`filter-search-container clearfix ${searchTextFocused ? 'focused ' : ''}`}>
                    <form onSubmit={this.onSearchTextSubmit}>
                      <input
                        ref={this.inputRef}
                        defaultValue={listSearchText}
                        type="text"
                        name="listSearchText"
                        onFocus={this.onSearchTextFocus}
                        onBlur={this.onSearchTextBlur}
                        onChange={this.onSearchTextChange}
                      />
                    </form>

                    {listSearchText ? (
                      <a href="#clearSearchTerm" onClick={this.resetSearchText}>
                        <i className="fal fa-times" />
                      </a>
                    ) : (
                      <i className="far fa-search" />
                    )}
                  </div>
                </div>
                <ul className="no-border">
                  {stateList.map(listItem => {
                    const value = listItemId(listItem);
                    const label = listItemFormatter(listItem);
                    const regexCheckLabel = listItemStringFormatter(listItem) || label;

                    let shouldSkip = (complete && !!listSearchText) || false;
                    if (complete && listSearchText) {
                      for (let i = 0; i < listSearchTextParts.length; i++) {
                        const regexCheck = new RegExp(`${_escapeRegExp(listSearchTextParts[i])}`, 'i');

                        if (regexCheck.exec(regexCheckLabel)) {
                          shouldSkip = false;
                          break;
                        }
                      }
                    }

                    return shouldSkip ? null : (
                      <li key={value}>
                        <a
                          className="p-t-5 p-b-5 relative block"
                          href="#updateFilter"
                          onClick={e => this.updateFilter(e, listItem)}
                        >
                          <ListFilterListEntry isChecked={selectedValue.value === value} label={label} />
                        </a>
                      </li>
                    );
                  })}
                </ul>
                {list.pending && <Loader />}
              </div>
            </ScrollArea>
          </SidebarAwarePopover>
        </Overlay>
      </>
    );
  }
}
ListFilterAsyncSingle.defaultProps = {
  listName: 'clients',
  listUrl: '/api/clients.json',
  paramName: 'target',
  listItemFormatter: () => {
    return 'no list item formatter';
  },
  listItemStringFormatter: () => null,
  listItemId: listItem => listItem.id,
  complete: false,
};

const mapStateToProps = (state, ownProps) => {
  return {
    list: state.list[ownProps.listName],
  };
};
const mapDispatchToProps = dispatch => {
  return {
    changeActivePage: (listName, activePage, resPerPage) => {
      dispatch(changeActivePage(listName, activePage, resPerPage));
    },
  };
};

export default injectIntl(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ListFilterAsyncSingle)
  )
);
